import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";

function PolitiqueConfidentialite() {
  return (
    <div className="landing-page-component politique-confidentialite-page">
      <FrontHeader />
      <div className="page-content pb-5">
        <div className="container politique-confidentialite__container">
          <h1 className="politique-confidentialite__title">
            Politique de confidentialité
          </h1>

          <p className="politique-confidentialite__date">
            <strong>Dernière mise à jour :</strong> 16/03/2026
          </p>

          <div className="politique-confidentialite__content">
            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-intro"
            >
              <h2 id="pc-intro" className="politique-confidentialite__heading">
                1.1 Introduction
              </h2>
              <p className="politique-confidentialite__body">
                <strong>KAZAMANSA</strong>, accessible depuis{" "}
                <strong>Kazamansa.com</strong>, est une plateforme de commerce
                électronique qui permet aux utilisateurs d&apos;acheter des
                produits et services en ligne. Cette politique de confidentialité
                décrit comment nous collectons, utilisons et partageons les
                informations personnelles des utilisateurs de notre plateforme.
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-collecte"
            >
              <h2 id="pc-collecte" className="politique-confidentialite__heading">
                1. Informations collectées
              </h2>
              <p className="politique-confidentialite__body">
                Nous collectons les informations personnelles des utilisateurs
                de la manière suivante :
              </p>

              <h3
                id="pc-donnees-perso"
                className="politique-confidentialite__subheading"
              >
                2.1 Données personnelles collectées
              </h3>
              <p className="politique-confidentialite__body">
                Lorsque vous utilisez <strong>KAZAMANSA</strong>, nous pouvons
                collecter les types de données personnelles suivants :
              </p>
              <ul className="politique-confidentialite__list">
                <li>
                  <strong>Informations d&apos;identification :</strong> nom,
                  prénom, adresse e-mail, numéro de téléphone, adresse postale.
                </li>
                <li>
                  <strong>Informations de paiement :</strong> informations de
                  carte de crédit ou de compte bancaire (le cas échéant).
                </li>
                <li>
                  <strong>Informations de connexion :</strong> nom
                  d&apos;utilisateur, mot de passe et autres informations
                  d&apos;authentification.
                </li>
                <li>
                  <strong>Informations de commande :</strong> détails de vos
                  commandes, historique d&apos;achat et informations de
                  livraison.
                </li>
                <li>
                  <strong>Informations de navigation :</strong> adresse IP,
                  données de navigation, type de navigateur, préférences de
                  langue.
                </li>
                <li>
                  <strong>Informations sur l&apos;appareil :</strong> type
                  d&apos;appareil, système d&apos;exploitation, identifiant
                  unique de l&apos;appareil.
                </li>
              </ul>

              <h3 className="politique-confidentialite__subheading">
                2.2 Informations collectées automatiquement
              </h3>
              <p className="politique-confidentialite__body">
                Nous collectons automatiquement certaines informations lorsque
                les utilisateurs interagissent avec notre plateforme. Ces
                informations peuvent inclure l&apos;adresse IP, le type de
                navigateur, le système d&apos;exploitation, les pages visitées,
                et les actions effectuées sur notre plateforme.
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-utilisation"
            >
              <h2
                id="pc-utilisation"
                className="politique-confidentialite__heading"
              >
                3. Utilisation des informations
              </h2>
              <p className="politique-confidentialite__body">
                Nous utilisons les informations personnelles des utilisateurs
                aux fins suivantes :
              </p>
              <ul className="politique-confidentialite__list">
                <li>
                  <strong>Pour fournir nos services :</strong> Nous utilisons
                  les informations personnelles des utilisateurs pour fournir
                  nos services, notamment pour traiter les commandes, livrer
                  les produits, et fournir un support client.
                </li>
                <li>
                  <strong>Pour améliorer nos services :</strong> Nous utilisons
                  les informations personnelles des utilisateurs pour améliorer
                  nos services, particulièrement pour analyser les tendances,
                  identifier les problèmes, et développer de nouvelles
                  fonctionnalités.
                </li>
                <li>
                  <strong>Pour vous contacter :</strong> Nous pouvons utiliser
                  les informations personnelles des utilisateurs pour les
                  contacter, notamment pour les informer des changements
                  apportés à nos services ou pour répondre à leurs questions ou
                  demandes.
                </li>
                <li>
                  <strong>
                    Pour vous envoyer des communications marketing :
                  </strong>{" "}
                  Nous pouvons utiliser les informations personnelles des
                  utilisateurs pour leur envoyer des communications marketing,
                  notamment des offres spéciales, des informations sur les
                  produits et services, et des invitations à des événements.
                </li>
              </ul>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-partage"
            >
              <h2 id="pc-partage" className="politique-confidentialite__heading">
                4. Partage des informations
              </h2>
              <p className="politique-confidentialite__body">
                Nous ne partageons les informations personnelles des utilisateurs
                qu&apos;avec les tiers suivants :
              </p>
              <ul className="politique-confidentialite__list politique-confidentialite__list--middot">
                <li>
                  <strong>Nos partenaires commerciaux :</strong> Nous pouvons
                  partager les informations personnelles des utilisateurs avec
                  nos partenaires commerciaux qui nous aident à fournir nos
                  services, notamment les sociétés de transport, les
                  prestataires de services de paiement, et les sociétés
                  d&apos;analyse.
                </li>
                <li>
                  <strong>Les autorités publiques :</strong> Nous pouvons
                  partager les informations personnelles des utilisateurs avec
                  les autorités publiques si nous sommes tenus de le faire par
                  la loi ou si nous pensons que cela est nécessaire pour
                  protéger nos droits ou les droits de tiers.
                </li>
              </ul>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-securite"
            >
              <h2 id="pc-securite" className="politique-confidentialite__heading">
                5. Sécurité des informations
              </h2>
              <p className="politique-confidentialite__body">
                Nous prenons des mesures de sécurité pour protéger les
                informations personnelles des utilisateurs, notamment des
                mesures techniques et organisationnelles. Ces mesures comprennent
                des pare-feu, des contrôles d&apos;accès, et des procédures de
                cryptage.
              </p>
            </section>

            <section className="politique-confidentialite__section" aria-labelledby="pc-droits">
              <h2 id="pc-droits" className="politique-confidentialite__heading">
                6. Droits des utilisateurs
              </h2>
              <p className="politique-confidentialite__body">
                Les utilisateurs ont les droits suivants en ce qui concerne leurs
                informations personnelles :
              </p>
              <ul className="politique-confidentialite__list">
                <li>
                  <strong>Le droit d&apos;accès :</strong> Les utilisateurs ont
                  le droit d&apos;accéder à leurs informations personnelles et de
                  demander qu&apos;elles soient mises à jour ou corrigées.
                </li>
                <li>
                  <strong>Le droit à l&apos;effacement :</strong> Les utilisateurs
                  ont le droit de demander que leurs informations personnelles
                  soient effacées.
                </li>
                <li>
                  <strong>Le droit à la limitation du traitement :</strong> Les
                  utilisateurs ont le droit de demander que le traitement de
                  leurs informations personnelles soit limité.
                </li>
                <li>
                  <strong>Le droit à la portabilité des données :</strong> Les
                  utilisateurs ont le droit de recevoir leurs informations
                  personnelles dans un format structuré et lisible par machine.
                </li>
                <li>
                  <strong>Le droit d&apos;opposition :</strong> Les utilisateurs
                  ont le droit de s&apos;opposer au traitement de leurs
                  informations personnelles pour des raisons légitimes.
                </li>
              </ul>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-contact"
            >
              <h2 id="pc-contact" className="politique-confidentialite__heading">
                7. Contact
              </h2>
              <p className="politique-confidentialite__body">
                Pour exercer ces droits, veuillez nous écrire à{" "}
                <strong>contact@kazamansa.com</strong>
              </p>
            </section>

            <section
              className="politique-confidentialite__section"
              aria-labelledby="pc-modifications"
            >
              <h2
                id="pc-modifications"
                className="politique-confidentialite__heading"
              >
                8. Modification de cette politique de confidentialité
              </h2>
              <p className="politique-confidentialite__body">
                Nous nous réservons le droit de modifier cette politique de
                confidentialité à tout moment. Les modifications seront
                affichées sur notre site Web et vous serez informé des changements
                importants par d&apos;autres moyens appropriés.
              </p>
            </section>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default PolitiqueConfidentialite;
